import { render, staticRenderFns } from "./PaymentChannels.vue?vue&type=template&id=1650f84c&scoped=true"
import script from "./PaymentChannels.vue?vue&type=script&lang=js"
export * from "./PaymentChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650f84c",
  null
  
)

export default component.exports